import { Spinner } from '../../../school_panel/components/ui';
import { useBlobUrl } from '../../../school_panel/pages/paper_exams/components/useBlobUrl';

interface Props { url: string; index: number; total: number; onOpen: () => void }

/** One answer-photo thumbnail; clicking opens the viewer. */
export default function AnswerPhotoThumb({ url, index, total, onOpen }: Props) {
  const { objectUrl, loading, error } = useBlobUrl(url);
  const alt = `Answer photo ${index + 1} of ${total}`;
  if (error) {
    return (
      <div className="flex h-24 w-24 items-center justify-center rounded-[12px] bg-danger-bg p-2 text-center text-xs text-danger-ink">
        Couldn&apos;t load photo
      </div>
    );
  }
  return (
    <button type="button" onClick={onOpen}
      className="flex h-24 w-24 items-center justify-center overflow-hidden rounded-[12px] border border-line bg-surface-2">
      {loading || !objectUrl ? <Spinner size="sm" /> : <img src={objectUrl} alt={alt} className="h-full w-full object-cover" />}
    </button>
  );
}
